module.exports = __webpack_public_path__ + "img/MBBANK.430c4e48.svg";